import { render, staticRenderFns } from "./WrapperPreviewCategory.vue?vue&type=template&id=789e8b6e"
import script from "./WrapperPreviewCategory.vue?vue&type=script&lang=js"
export * from "./WrapperPreviewCategory.vue?vue&type=script&lang=js"
import style0 from "./WrapperPreviewCategory.vue?vue&type=style&index=0&id=789e8b6e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports